import type { ReactNode } from 'react';

import AdminPanelSettingsTwoTone from '@mui/icons-material/AdminPanelSettingsTwoTone';
import AssessmentTwoTone from '@mui/icons-material/AssessmentTwoTone';
import HelpTwoTone from '@mui/icons-material/HelpTwoTone';
import DesignServicesTwoToneIcon from '@mui/icons-material/DesignServicesTwoTone';
import TableChartTwoToneIcon from '@mui/icons-material/TableChartTwoTone';
import AccountCircleTwoToneIcon from '@mui/icons-material/AccountCircleTwoTone';
import SmartToyTwoToneIcon from '@mui/icons-material/SmartToyTwoTone';

export interface MenuItem {
  link?: string;
  icon?: ReactNode;
  badge?: string;
  badgeTooltip?: string;

  items?: MenuItem[];
  name: string;

  roles?: string[];
  Detailroles?: userrole[];

}

export interface MenuItems {
  items: MenuItem[];
  heading: string;
}

export interface userrole {
    rolename: string[];
}

const menuItems: MenuItems[] = [
  {
    heading: '',
    items: [
      {
        name: 'Dashboard',
        icon: SmartToyTwoToneIcon,
        link: '/dashboard',
        roles: ['Admin', 'User', 'CoSec', 'HRAdmin', 'HRAdminSup', 'FinAdmin'],
        items: [
          {
            name: 'Dashboard 1',
            link: '/dashboard/banking',
            roles: ['Admin', 'User', 'CoSec', 'HRAdmin', 'HRAdminSup', 'FinAdmin']
          }
        ]
      },
      {
        name: 'Options',
        icon: DesignServicesTwoToneIcon,
        link: '/options',
        roles: ['Admin', 'User', 'CoSec', 'HRAdmin', 'HRAdminSup', 'FinAdmin'],
        items: [
          {
            name: 'Personal Ledger',
            link: '/options/personalLedger',
            roles: ['Admin', 'User', 'CoSec', 'HRAdmin', 'HRAdminSup', 'FinAdmin']
          },
          {
            name: 'Accept Offer',
            link: '/options/acceptOffer',
            roles: ['Admin', 'User', 'CoSec', 'HRAdmin', 'HRAdminSup', 'FinAdmin']
          },
          {
            name: 'Exercise Option',
            link: '/options/exerciseOption',
            roles: ['Admin', 'User', 'CoSec', 'HRAdmin', 'HRAdminSup', 'FinAdmin']
          }
        ]
      },
      {
        name: 'Awards',
        icon: TableChartTwoToneIcon,
        link: '/awards',
        roles: ['Admin', 'User', 'CoSec', 'HRAdmin', 'HRAdminSup', 'FinAdmin'],
        items: [
          {
            name: 'Personal Ledger',
            link: '/awards/personalLedger',
            roles: ['Admin', 'User', 'CoSec', 'HRAdmin', 'HRAdminSup', 'FinAdmin']
          },
          {
            name: 'View Award',
            link: '/awards/viewAward',
            roles: ['Admin', 'User', 'CoSec', 'HRAdmin', 'HRAdminSup', 'FinAdmin']
          }
        ]
      },
      {
        name: 'Accounts',
        icon: AccountCircleTwoToneIcon,
        link: '/Accounts',
        roles: ['Admin', 'User', 'CoSec', 'HRAdmin', 'HRAdminSup', 'FinAdmin'],
        items: [
          {
            name: 'User Profile',
            link: '/accounts/profile',
            roles: ['Admin', 'User', 'CoSec', 'HRAdmin', 'HRAdminSup', 'FinAdmin']
          },
          {
            name: 'Change Password',
            link: '/accounts/changePassword',
            roles: ['Admin', 'User', 'CoSec', 'HRAdmin', 'HRAdminSup', 'FinAdmin']
          },
          {
            name: 'Register MFA',
            link: '/accounts/RegisterMFA',
            roles: ['Admin', 'User', 'CoSec', 'HRAdmin', 'HRAdminSup', 'FinAdmin']
          }
        ]
      },
      {
        name: 'Administration',
        icon: AdminPanelSettingsTwoTone,
        link: '/Administrator',
        roles: ['Admin', 'CoSec', 'HRAdmin', 'HRAdminSup'],
        items: [
          {
            name: 'ESOP - Grant',
            link: '/Administrator/EsopGrant',
            roles: ['Admin', 'CoSec', 'HRAdmin', 'HRAdminSup'],
            items: [
              {
                name: 'Create New Grant',
                link: '/Administrator/EsopGrant/createGrant',
                roles: ['Admin']
              },
              {
                name: 'Maintain Grant',
                link: '/Administrator/EsopGrant/maintainGrant',
                roles: ['Admin', 'HRAdmin', 'HRAdminSup']
              },
              {
                name: 'Send Grant for Approval',
                link: '/Administrator/EsopGrant/sendGrant',
                roles: ['Admin']
              },
              {
                name: 'Generate Offer Letter',
                link: '/Administrator/EsopGrant/generateOffer',
                roles: ['Admin']
              },
              {
                name: 'Manual Acceptance',
                link: '/Administrator/EsopGrant/manualAcceptance',
                roles: ['Admin']
              }
            ]
          },
          {
            name: 'ESOP - Upload',
            link: '/Administrator/EsopUpload',
            roles: ['Admin'],
            items: [
              {
                name: 'Upload Grant List',
                link: '/Administrator/EsopUpload/uploadGrant',
                roles: ['Admin']
              }
            ]
          },
          {
            name: 'ESOP - Option',
            link: '/Administrator/EsopOption',
            roles: ['Admin', 'CoSec', 'HRAdmin', 'HRAdminSup'],
            items: [
              {
                name: 'Enter Blackout Period',
                link: '/Administrator/EsopOption/blackoutPeriod',
                roles: ['Admin']
              },
              {
                name: 'Manual Exercise',
                link: '/Administrator/EsopOption/manualExercise',
                roles: ['Admin']
              },
              {
                name: 'Enter Payment',
                link: '/Administrator/EsopOption/enterPayment',
                roles: ['Admin']
              },
              {
                name: 'Exercise Process',
                link: '/Administrator/EsopOption/exerciseProcess',
                roles: ['Admin', 'CoSec', 'HRAdmin', 'HRAdminSup']
              },
              {
                name: 'Enter Listing/Crediting/Net Asset Value Date',
                link: '/Administrator/EsopOption/assetValue',
                roles: ['Admin']
              }
            ]
          },
          {
            name: 'ESOP - Approval',
            link: '/Administrator/EsopApproval',
            roles: ['HRAdminSup'],
            items: [
              {
                name: 'Approve Grant',
                link: '/Administrator/EsopApproval/approveGrant',
                roles: ['HRAdminSup']
              },
              {
                name: 'Approve Option Retention',
                link: '/Administrator/EsopApproval/approveRetention',
                roles: ['HRAdminSup']
              }
            ]
          },
          {
            name: 'PSP/RSP - Award',
            link: '/Administrator/PspAward',
            roles: ['Admin', 'HRAdmin', 'HRAdminSup'],
            items: [
              {
                name: 'Create New Award',
                link: '/Administrator/PspAward/createAward',
                roles: ['Admin']
              },
              {
                name: 'Maintain Award',
                link: '/Administrator/PspAward/maintainAward',
                roles: ['Admin', 'HRAdmin', 'HRAdminSup']
              },
              {
                name: 'Send Award For Approval',
                link: '/Administrator/PspAward/sendAward',
                roles: ['Admin']
              },
              {
                name: 'Generate Award Email',
                link: '/Administrator/PspAward/generateAward',
                roles: ['Admin']
              },
              {
                name: 'Enter Award Factor',
                link: '/Administrator/PspAward/awardFactor',
                roles: ['Admin']
              }
            ]
          },
          {
            name: 'PSP/RSP - Upload',
            link: '/Administrator/PspUpload',
            roles: ['Admin'],
            items: [
              {
                name: 'Upload Award List',
                link: '/Administrator/PspUpload/uploadAward',
                roles: ['Admin']
              }
            ]
          },
          {
            name: 'PSP/RSP - Share',
            link: '/Administrator/PspShare',
            roles: ['Admin', 'CoSec', 'HRAdmin', 'HRAdminSup'],
            items: [
              {
                name: 'Crediting Process',
                link: '/Administrator/PspShare/creditingProcess',
                roles: ['Admin', 'CoSec', 'HRAdmin', 'HRAdminSup']
              },
              {
                name: 'Enter Listing/Crediting Date',
                link: '/Administrator/PspShare/creditingDate',
                roles: ['Admin']
              },
              {
                name: 'Enter Payment Date',
                link: '/Administrator/PspShare/paymentDate',
                roles: ['Admin']
              }
            ]
          },
          {
            name: 'PSP/RSP - Approval',
            link: '/Administrator/PspApproval',
            roles: ['HRAdminSup'],
            items: [
              {
                name: 'Approve Award',
                link: '/Administrator/PspApproval/approveAward',
                roles: ['HRAdminSup']
              },
              {
                name: 'Approve Retention',
                link: '/Administrator/PspApproval/approveRetention',
                roles: ['HRAdminSup']
              }
            ]
          },
          {
            name: 'System',
            link: '/Administrator/System',
            roles: ['Admin', 'HRAdmin', 'HRAdminSup'],
            items: [
              {
                name: 'Upload User Profile',
                link: '/Administrator/System/uploadProfile',
                roles: ['Admin']
              },
              {
                name: 'Manage User Profile',
                link: '/Administrator/System/manageProfile',
                roles: ['Admin', 'HRAdmin', 'HRAdminSup']
              },
              {
                name: 'Manage Lookup Table',
                link: '/Administrator/System/manageLookup',
                roles: ['Admin', 'HRAdmin', 'HRAdminSup']
              }
            ]
          }
        ]
      },
      {
        name: 'Reports',
        icon: AssessmentTwoTone,
        link: '/Reports',
        roles: ['Admin', 'CoSec', 'HRAdmin', 'HRAdminSup', 'FinAdmin'],
        items: [
          {
            name: 'ESOP Personal Ledger',
            link: '/Reports/esopPersonalLedger',
            roles: ['Admin' , 'HRAdmin', 'HRAdminSup']
          },
          {
            name: 'PSP/RSP Personal Ledger',
            link: '/Reports/pspPersonalLedger',
            roles: ['Admin' , 'HRAdmin', 'HRAdminSup']
          },
          {
            name: 'ESOP - Grant Offer Report',
            link: '/Reports/esopGrantOffer',
            roles: ['Admin' , 'HRAdmin', 'HRAdminSup']
          },
          {
            name: 'ESOP - Grant Summary Report',
            link: '/Reports/esopGrantSummary',
            roles: ['Admin', 'CoSec', 'HRAdmin', 'HRAdminSup', 'FinAdmin']
          },
          {
            name: 'ESOP - Master Option Report',
            link: '/Reports/esopMasterOption',
            roles: ['Admin' , 'HRAdmin', 'HRAdminSup']
          },
          {
            name: 'ESOP - Exercise Report',
            link: '/Reports/esopExcercise',
            roles: ['Admin' , 'HRAdmin', 'HRAdminSup']
          },
          {
            name: 'ESOP - Expense Report',
            link: '/Reports/esopExpense',
            roles: ['Admin', 'HRAdmin', 'HRAdminSup', 'FinAdmin']
          },
          {
            name: 'PSP/RSP - Master Share Report',
            link: '/Reports/pspMasterShare',
            roles: ['Admin' , 'HRAdmin', 'HRAdminSup']
          },
          {
            name: 'PSP/RSP - Award Summary Report',
            link: '/Reports/pspAwardSummary',
            roles: ['Admin', 'CoSec', 'HRAdmin', 'HRAdminSup', 'FinAdmin']
          },
          {
            name: 'PSP/RSP - Vesting Report',
            link: '/Reports/pspVesting',
            roles: ['Admin', 'HRAdmin', 'HRAdminSup']
          },
          {
            name: 'PSP/RSP - Allotment Report',
            link: '/Reports/pspAllotment',
            roles: ['Admin', 'CoSec', 'HRAdmin', 'HRAdminSup']
          },
          {
            name: 'PSP/RSP - Expense Report',
            link: '/Reports/pspExpense',
            roles: ['Admin', 'HRAdmin', 'HRAdminSup', 'FinAdmin']
          },
          {
            name: 'User Details Report',
            link: '/Reports/userDetails',
            roles: ['Admin', 'HRAdmin', 'HRAdminSup']
          },
          {
            name: 'Lapse Report',
            link: '/Reports/lapse',
            roles: ['Admin', 'HRAdmin', 'HRAdminSup']
          },
          {
            name: 'Gains Report',
            link: '/Reports/gains',
            roles: ['Admin', 'HRAdmin', 'HRAdminSup']
          }
        ]
      },
      {
        name: 'Help',
        icon: HelpTwoTone,
        link: '/help',
        roles: ['Admin', 'User', 'CoSec', 'HRAdmin', 'HRAdminSup', 'FinAdmin'],
        items: [
          {
            name: 'Contact Us',
            link: '/help/contactUs',
            roles: ['Admin', 'User', 'CoSec', 'HRAdmin', 'HRAdminSup', 'FinAdmin']
          },
          {
            name: 'Plan Rules',
            link: '/help/planRules',
            roles: ['Admin', 'User', 'CoSec', 'HRAdmin', 'HRAdminSup', 'FinAdmin']
          }
        ]
      },
    ]
  }
];

export default menuItems;
